import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Persists the child avatar block comments only. Frontend markup is produced
 * server-side by render.php (the parent is the sole frontend renderer).
 */
export default function Save() {
  return <InnerBlocks.Content />;
}
